export default "__VITE_PUBLIC_ASSET__f88c31c3__"